import { Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//components
import SearchTable from 'components/backoffice/table/SearchTable';
import CustomInput from 'components/backoffice/customInput';

const FiltersTable = ({
  formFilter,
  setFormFilter,
  handleClear,
  t,
  page,
  setPage
}) => {

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable
      handleClear={handleClear}
      multipleInput={true}
      className="d-flex align-items-center"
      md={9}
    >
     <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.name}
          label={t('nombre')}
          placeholder={t('nombre')}
          onChange={(e) => handleSearch(e, 'name')}
          data-testid="nombre"
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.code}
          label={t('codigo')}
          placeholder={t('codigo')}
          onChange={(e) => handleSearch(e, 'code')}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.email}
          label={t('correoelectronico')}
          placeholder={t('correoelectronico')}
          onChange={(e) => handleSearch(e, 'email')}
        />
      </Form>
    </SearchTable>
  )
}

FiltersTable.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTable;
